import { DEFAULT_SEASON } from '../Env'

export const FEATURE_NAME = 'schedules'

export interface FilterOption {
  id: string
  name: string
}

export const DefaultSeasonValue = {
  id: DEFAULT_SEASON,
  name: DEFAULT_SEASON.split('-').join(' - '),
}

export const gameTypes = [
  {
    id: 'Game',
    name: 'Game',
  },
  {
    id: 'Scrimmage',
    name: 'Scrimmage',
  },
]
